import React from "react";

const DescriptionSection = ({ section }) => {
  return (
    <section className="container">
      <div className="d-flex flex-column justify-content-between align-items-center p-4">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            flexDirection: "column",
            width: "82px",
            // margin: "0 auto",
            marginBottom: "10px",
          }}
        >
          <h3
            className="text-center"
            style={{
              color: "#AF9763",
              fontSize: "28px",
              fontWeight: "500",
            }}
          >
            {section.sectionTitle}
          </h3>
          {/* <img src="/assets/images/doctor_under.png" alt="" /> */}
        </div>
        <div
        //   className="text-center"
          dangerouslySetInnerHTML={{
            __html: section.value.content,
          }}
        ></div>
      </div>
    </section>
  );
};

export default DescriptionSection;



// WEBPACK FOOTER //
// ./src/component/frontend/DescriptionSection.js